export enum ParkingAreaType {
  DAY = "DAY",
  MINUTE = "MINUTE"
}